export default {
  home:"Home",
  dashboard:{
    label:'Dashboard'
  },
  general:{
    dashboard:'Dashboard'
  },
  domain:{
    view:'Übersicht',
    label:"Domains",
    create:"Bestellen",
    list:"Übersicht",
    deleted:"Gelöschte Domains",
    handles:'Handles',
    nameserver:'Nameserver',
    setup:'Einstellungen',
    prices:'Preisliste'
  },
  dns:{
    view:'Übersicht',
    label:"DNS",
    list:"Übersicht"
  },
  ssl:{
    view:'Übersicht',
    label:'SSL',
    list:'Übersicht'
  },
  datacenter:{
    view:'Übersicht',
    order:'Vserver Bestellen',
    label:'Serververwaltung',
    vserver:'Virtuelle Server',
    dedicated:'Dedizierte Server',
    teamspeaker:'Teamspeaker-Instanzen'
  },

  rz:{
    view:'Übersicht',
    label:'RZ-Technik',
    ddos:'DDoS-Alerts',
    ip:'IP-Netze',
    installation:'Rootserverinstallationen',
    operation:'Rootserveroperationen',
    traffic:'Traffic',
    pools:'Traffic-Pools'
  },
  licence:{
    label:'Lizenz',
    multicraft:'Multicraft'
  },
  account:{
    view:'Übersicht',
    label:'Benutzerverwaltung',
    subuser:'Unterbenutzer',
    details:'Accountdetails',
    task:'Auftragsverarbeitung'
  },
  accounting:{
    view:'Übersicht',
    label:'Buchhaltung',
    balance:'Kontostand',
    debit:'Lastschrift',
    bill:'Rechnungen',
    open:'Offene Positionen',
    transaction:'Transaktionen'
  },
  tools:{
    view:'Übersicht',
    label:'Tools'
  },
  support:{
    label:'Support'
  }
  // ssl:"SSL",
  // datacenter:"Serververwaltung",
  // rz:"RZ-Technik",
  // licence:"Lizenzen",
  // account:"Benutzerverwaltung",
  // accounting:"Buchhaltung",
  // tools:"Tools",
  // support:"Support"
}



// WEBPACK FOOTER //
// ./src/lang/de/sidebar.js